import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { TrustCenterFacadeService, RequirementsCategoryResponse, RequirementResponse } from '@anecdotes/shared-trust-center';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-control-side-panel',
  templateUrl: './control-side-panel.component.html',
  styleUrls: ['./control-side-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ControlSidePanelComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  @HostBinding('class')
  private readonly classes = 'h-full';

  editing: boolean;

  @Input()
  control: RequirementsCategoryResponse;

  get requirementsToShow(): RequirementResponse[] {
    if (this.editing) {
      return this.control.requirements;
    }

    return this.control.requirements.filter((req) => req.is_visible);
  }

  constructor(private trustCenterFacadeService: TrustCenterFacadeService, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.trustCenterFacadeService
      .isEditing()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((editing) => {
        this.editing = editing;
        this.cd.detectChanges();
      });
  }

  buildTranslationKey(relativeKey: string): string {
    return `trustCenter.${relativeKey}`;
  }
}
